import {isEmpty, isNil} from "lodash"
import {RewardCatalogueReward, RewardCatalogueProduct} from "@irati/types"

const locales = [
  {locale: "en-GB", currency: "GBP"},
  {locale: "en-AU", currency: "AUD"},
  {locale: "fr-FR", currency: "EUR"},
  {locale: "en-IE", currency: "EUR"}
]

export default function getCurrencyForReward(reward: RewardCatalogueReward) {
  if (reward) {
    const products = reward.products?.results
    if (!isEmpty(products)) {
      return getCurrencyForRewardProduct(products[0])
    } else if (!isNil(reward.locale)) {
      // ew, really best guessing here
      const item = locales.find((l) => l.locale === reward.locale)
      return item?.currency || ""
    }
  }

  return ""
}

export function getCurrencyForRewardProduct(product: RewardCatalogueProduct) {
  const currency = product?.currency
  if (currency) {
    return currency
  }
  // ew, really best guessing here
  const item = locales.find((l) => l.locale === product.locale)
  return item?.currency || ""
}
